export default function(array, indexes) {
  var i = indexes.length, permutes = new Array(i);
  while (i--) permutes[i] = array[indexes[i]];
  return permutes;
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/d3-array/src/permute.js
// module id = ./node_modules/d3-array/src/permute.js
// module chunks = vendor